<template>
  <v-container fluid class="main-container responsive-height">
    <v-row dense>
      <v-col lg="12" md="12" sm="12" cols="12">
        <v-sheet
          class="transactionTable pb-3"
          elevation="0"
          :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
        >
          <div class="title-bar pt-5">
            <div>
              <v-icon dense color="#5F7692">mdi-bag-checked</v-icon>
              <span class="ml-2">Change MT5 Trading Account Password</span>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <v-card
      class="deposit-form px-3 pb-10"
      :color="$vuetify.theme.dark ? '#172233' : '#E0EAF2'"
    >
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="9">
          <fieldset>
            <legend>Select Account No</legend>
            <v-select
              v-model="selectedAccount"
              :items="userleverages"
              :item-text="
                (item) =>
                  `${item.trading_account_no} (${item.tradingaccounttypes.account_type_display})`
              "
              item-value="trading_account_no"
              label="MT5 Account"
              single-line
              solo
              hide-details
              append-icon="mdi-chevron-down"
              class="custom-select"
              :readonly="!isEditable"
            >
            </v-select>
          </fieldset>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="9">
          <fieldset>
            <legend>New Password</legend>
            <v-text-field
              v-model="newPassword"
              label="New Password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              single-line
              solo
              hide-details
              class="custom-select"
            >
            </v-text-field>
          </fieldset>
        </v-col>
        <v-row class="px-3">
          <v-col
            v-for="(rule, index) in passwordRules"
            :key="index"
            cols="auto"
            class="flex-wrap wrap"
          >
            <v-chip small color="greenMain" text-color="white">
              <v-icon small class="mr-1">{{
                rule.met ? "mdi-check" : "mdi-close"
              }}</v-icon>
              {{ rule.text }}
            </v-chip>
          </v-col>
        </v-row>
        <v-col cols="12" sm="12" md="12" lg="9">
          <fieldset>
            <legend>Confirm Password</legend>
            <v-text-field
              v-model="confirmPassword"
              label="Confirm Password"
              placeholder="Write Password Again"
              :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showConfirmPassword ? 'text' : 'password'"
              @click:append="showConfirmPassword = !showConfirmPassword"
              single-line
              solo
              hide-details
              class="custom-select"
            >
            </v-text-field>
          </fieldset>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="9">
          <v-alert v-if="errorMessage" type="error" class="mb-4">
            {{ errorMessage }}
          </v-alert>

          <v-btn
            color="greenMain"
            large
            tile
            elevation="0"
            class="ma-0 mt-0 text-capitalize btn-account"
            v-bind="attrs"
            v-on="on"
            @click="savePassword"
            :loading="loading" :disabled="loading"
          >
            Save Password
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { LEVERAGE__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    isEditable: true,
    selectedAccount: "",
    currentPassword: "",
    loading: false,
    newPassword: "",
    confirmPassword: "",
    showPassword: false,
    showConfirmPassword: false,
    errorMessage: "",
    passwordRules: [
      { text: "8 Characters", met: false },
      { text: "1 Lowercase", met: false },
      { text: "1 Uppercase", met: false },
      { text: "1 Digit", met: false },
      { text: "1 Special Character", met: false },
    ],
  }),

  computed: {
    ...mapState("leverage", ["userleverages"]),
  },

  watch: {
    newPassword() {
      this.validatePassword();
    },
    selectedAccount(newAccount) {
      const account = this.userleverages.find(
        (item) => item.trading_account_no === newAccount
      );
      if (account) {
        this.currentLeverage = `1:${account.leverage}`;
      } else {
        this.currentLeverage = "";
      }
    },
  },

  methods: {
    ...mapActions("leverage", [
      LEVERAGE__ACTIONS.USERLEVERAGE,
      LEVERAGE__ACTIONS.UPDATEMT5PASSWORD,
    ]),
    validatePassword() {
      this.passwordRules[0].met = this.newPassword.length >= 8;
      this.passwordRules[1].met = /[a-z]/.test(this.newPassword);
      this.passwordRules[2].met = /[A-Z]/.test(this.newPassword);
      this.passwordRules[3].met = /\d/.test(this.newPassword);
      this.passwordRules[4].met = /[!@#$%^&*(),.?":{}|<>]/.test(
        this.newPassword
      );
    },

    async savePassword() {
      this.loading = true;
      try {
        if (this.newPassword !== this.confirmPassword) {
          this.errorMessage = "Passwords do not match!";
          return;
        }

        this.errorMessage = "";

        await this[LEVERAGE__ACTIONS.UPDATEMT5PASSWORD]({
          login_acc: this.selectedAccount,
          new_password: this.newPassword,
        });

      } catch (error) {
        console.error('Trading Account Password change error:', error.message);
        this.errorMessage = "An error occurred while updating the password.";
      } finally {
        this.selectedAccount = "";
        this.newPassword = "";
        this.confirmPassword = "";
        this.loading = false;
      }
    }

  },

  async mounted() {
    const account = this.$route.query.account;
    await this[LEVERAGE__ACTIONS.USERLEVERAGE]();

    if (account) {
      this.selectedAccount = account;
      this.isEditable = false;
    }
  },
};
</script>
